import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

import type { ProductIconName } from './ProductIcon';

const messages = defineMessages({
  sharedTitle: {
    id: 'Team.inviteTray.sharedTitle',
    defaultMessage: 'Coinbase Business',
    description: 'Title for the Coinbase Business product row',
  },
  sharedDescription: {
    id: 'Team.inviteTray.sharedDescription',
    defaultMessage: 'Crypto payments and treasury',
    description: 'Description for the Coinbase Business product row',
  },
  accountManagementTitle: {
    id: 'Team.inviteTray.accountManagementTitle',
    defaultMessage: 'Admin Settings',
    description: 'Title for the Admin Settings product row',
  },
  accountManagementDescription: {
    id: 'Team.inviteTray.accountManagementDescription',
    defaultMessage: 'Manage team and permissions',
    description: 'Description for the Admin Settings product row',
  },
  cdpTitle: {
    id: 'Team.inviteTray.cdpTitle',
    defaultMessage: 'Developer Platform',
    description: 'Title for the Developer Platform product row',
  },
  cdpDescription: {
    id: 'Team.inviteTray.cdpDescription',
    defaultMessage: 'Build onchain apps',
    description: 'Description for the Developer Platform product row',
  },
});

export type ProductDefinition = {
  productKey: string;
  iconName: ProductIconName;
  iconBackground: string;
  titleMessage: MessageDescriptor;
  descriptionMessage: MessageDescriptor;
};

export type FormatMessage = (message: MessageDescriptor) => string;

// TODO: Codify these product icon colors into theme instead of inline CSS vars.
export const PRODUCTS: ProductDefinition[] = [
  {
    productKey: 'shared',
    iconName: 'briefcase',
    iconBackground: 'rgb(var(--orange5))',
    titleMessage: messages.sharedTitle,
    descriptionMessage: messages.sharedDescription,
  },
  {
    productKey: 'account_management',
    iconName: 'gear',
    iconBackground: 'rgb(var(--gray15))',
    titleMessage: messages.accountManagementTitle,
    descriptionMessage: messages.accountManagementDescription,
  },
  {
    productKey: 'cdp',
    iconName: 'api',
    iconBackground: 'rgb(var(--purple5))',
    titleMessage: messages.cdpTitle,
    descriptionMessage: messages.cdpDescription,
  },
];

export function getProductDefinition(productKey: string) {
  return PRODUCTS.find((product) => product.productKey === productKey);
}

export function getProductDisplayName(
  productKey: string,
  formatMessage: FormatMessage,
  fallback = productKey,
) {
  const product = getProductDefinition(productKey);
  return product ? formatMessage(product.titleMessage) : fallback;
}
